module.exports = __webpack_public_path__ + "img/15.64699f3a.svg";